
export class DescriptionNode
{
    public readonly parent:DescriptionNode;
    public readonly objectFields:any;
    public readonly arrayFields:any;
    public readonly fields:any;

    constructor(json:any)
    {
        this.parent = json['parent']? new DescriptionNode(json['parent']):null;
        this.objectFields = json['objectFields'];
        this.arrayFields = json['arrayFields'];
        this.fields = json['fields'];
    }
}
